import React, { useState, ReactNode } from "react";

type TooltipProps = {
  content: ReactNode; // Accept JSX/HTML content
  children: ReactNode;
  position?: "top" | "right" | "bottom" | "left";
  className?: string;
  type?: string;
};

const HoverTooltip: React.FC<TooltipProps> = ({
  content,
  children,
  position = "top",
  className,
  type
}) => {
  const [visible, setVisible] = useState(false);

  const positionClass = {
    top: "bottom-22px start-50 translate-middle-x",
    right: "start-100 top-50 translate-middle-y",
    bottom: "top-100 start-50 translate-middle-x",
    left: "end-100 top-50 translate-middle-y",
  };

  return (
    <div
      className="position-relative d-inline-block cursor-pointer"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}

      {visible && (
        <>
          <div
            className={`${className ? className : `w-315px min-w-315px position-absolute text-black px-15px py-10px rounded small ${positionClass[position]}`}`}
            style={{
              zIndex: 1000,
              boxShadow: "-4px 4px 20px 0 rgba(0,0,0,0.15)",
            }}
          >
            {content}
            { type !== 'job' ? 
            <svg
              style={{
                position: "absolute",
                left: "50%",
                marginLeft: "-18px",
                bottom: "-15px",
              }}
              width="37"
              height="22"
              viewBox="0 0 37 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.5 22L0.746481 0.249997L36.2535 0.25L18.5 22Z"
                fill="#C0F2EE"
              />
            </svg> : "" }
          </div>
        </>
      )}
    </div>
  );
};

export default HoverTooltip;
